// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_bg-b";
export var colorBlue = "_bg-8";
export var colorDot = "_bg-0";
export var colorDotLarge = "_bg-2";
export var colorDotSmall = "_bg-1";
export var colorGreen = "_bg-7";
export var colorGrey = "_bg-3";
export var colorOrange = "_bg-5";
export var colorPink = "_bg-a";
export var colorPurple = "_bg-9";
export var colorRed = "_bg-4";
export var colorYellow = "_bg-6";